import React, { useContext } from "react"
import { FaMapMarkerAlt } from "react-icons/fa"
import { ThemeContext } from "../layout"
import "./Timeline.scss"

const timelineData = [
  {
    id: "1",
    title: "Lead Developer",
    companyName: "Teknuance",
    location: "Chennai",
    achievements: [
      <>
        Lead the development of a fully fledged and highly customizable Charts
        library built on top of React.js and D3.js in a team of 3.
      </>,
      <>
        Mentored, guided and collaborated with new teammates on multiple
        projects.
      </>,
      <>Contributed in the back-end development with Node.js.</>,
    ],
    tenure: "July '19 - Present",
  },
  {
    id: "2",
    title: "Front-end Developer",
    companyName: "Teknuance",
    location: "Chennai",
    achievements: [
      <>
        Developed a real time social networking application with features
        involving messaging, peer to peer and conference calling, etc. using
        React, WebRTC and Socket.io.
      </>,
      <>
        Built the front-end for a database modelling tool with high scalability.
      </>,
      <>
        Extensively worked on developing a wide variety of reusable data driven
        charts using D3.js and React.
      </>,
      <>
        Created a sophisticated Rich Text suggestion box and several other
        reusable components for multiple projects.
      </>,
    ],
    tenure: "July '18 - July '19",
  },
  {
    id: "3",
    title: "Research Analyst Intern",
    companyName: "Teknuance",
    location: "Chennai",
    achievements: [
      <>
        Developed a reusable UI component toolkit using React.js and Typescript.
      </>,
      <>
        Worked on different approaches for integrating D3.js with React.js and
        creating reusable chart components.
      </>,
    ],
    tenure: "Feb '18 - June '18",
  },
]

// Change title font-size for mobile devices

function Timeline({ items }) {
  const theme = useContext(ThemeContext)
  return (
    <div
      className={`timeline-box ${
        theme === "dark" ? "timeline-box-is-dark" : ""
      }`}
    >
      <div className="timeline-box-start" />
      <ul>
        {timelineData.map(timelineItem => (
          <li key={timelineItem.id}>
            <span></span>
            <div className="box has-background-light">
              <div className="title is-5">{timelineItem.title}</div>
              <div className="subtitle company-info has-text-grey-dark">
                <span className="icon">
                  <FaMapMarkerAlt />
                </span>
                {timelineItem.companyName}, {timelineItem.location}
              </div>
              <div className="content">
                <ul>
                  {timelineItem.achievements.map((achievment, index) => (
                    <li key={index}>{achievment}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="time">
              <span>{timelineItem.tenure}</span>
            </div>
          </li>
        ))}
      </ul>
      <div className="timeline-box-end" />
    </div>
  )
}

export default Timeline
